var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonaire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012a87",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 0H11L0 10v14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d90f",
    d: "M0 0v10L11 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.93 9.62 15 9l-1.07-.62a5 5 0 0 0-4.31-4.31L9 3l-.62 1.07a5 5 0 0 0-4.31 4.31L3 9l1.07.62a5 5 0 0 0 4.31 4.31L9 15l.62-1.06a5 5 0 0 0 4.31-4.32M9 13.33a4.34 4.34 0 1 1 .01-8.68A4.34 4.34 0 0 1 9 13.33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc171d",
    d: "m10.71 9 .86-1.48H9.86L9 6.03l-.86 1.49H6.43L7.29 9l-.86 1.48h1.71L9 11.97l.86-1.49h1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonaire);
export default __webpack_public_path__ + "static/media/bonaire.c4f282b2c34499a7aaae525179e2c082.svg";
export { ForwardRef as ReactComponent };